import React from 'react';

import {
    DisclaimerText,
    Link,
    PageSection,
    SubHeading,
} from 'reaxl';
import { sendClick } from 'reaxl-analytics';
import { psxVDPFaqClick } from 'reaxl-analytics-handlers';

function PsxFraudContainer() {

    return (
        <PageSection
            alignment="left"
            className="col-lg-8"
            uiContext="level-3"
            subheading="More About Vehicle Details & Information"
        >
            <DisclaimerText componentClass="p">
                All vehicle specification data is pulled electronically from external sources.
                Some information may be duplicative or conflicting. If you have questions regarding
                a vehilce&rsquo;s condition and or any specifications listed here, pelase reach out to the
                seller using the button above.
            </DisclaimerText>

            <SubHeading size={400}>Suspect fraud?</SubHeading>
            <DisclaimerText componentClass="p">
                No verification process is 100% error- or tamper-free. Awareness is the best defense.
                {' '}
                <Link
                    onClick={(event) => sendClick(psxVDPFaqClick, event, {})}
                    href="/marketplace/faqs"
                    target="_blank"
                    rel="nofollow noopener"
                >
                    Please read our frequently asked questions
                </Link>
                {' '}
                for things you can do to help protect yourself against fraud.
            </DisclaimerText>
        </PageSection>
    );
}

export default PsxFraudContainer;
